class TecobiSmsWidgetService {

    constructor(
        $http,
        $mdToast
    ) {
        'ngInject';

        this.$http = $http;
        this.$mdToast = $mdToast;
        this.apiUrl = 'https://api.tecobi.com/api/v3';

    }

    getClientInfo(clientId) {

        const req = {
            method: 'GET',
            url: `${this.apiUrl}/client-widgets/${clientId}/`
        }
        return this.$http(req).then((response) => {
            this.clientInfo = response.data;
            // Un-comment this line to test null config
            //this.clientInfo.smswidgetconfig = null;
            // FB Pixel code piggy backed on config response
            if(this.clientInfo.fb_pixel_id && this.clientInfo.smswidgetconfig && this.clientInfo.smswidgetconfig.pixel_enabled) {
                !function(f,b,e,v,n,t,s)
                {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                n.queue=[];t=b.createElement(e);t.async=!0;
                t.src=v;s=b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t,s)}(window, document,'script',
                'https://connect.facebook.net/en_US/fbevents.js');
                fbq('init', this.clientInfo.fb_pixel_id);
                fbq('track', 'PageView');
            }
        });
    }

    showSuccessToast() {
        this.$mdToast.show(
            this.$mdToast.simple()
                .textContent('Check your phone for a text!')
                .position('bottom right')
                .hideDelay(5000)
        );
    }

    showErrorToast() {
        this.$mdToast.show(
            this.$mdToast.simple()
                .textContent('Oops, there was an error on our end!')
                .position('bottom right')
                .hideDelay(5000)
        );
    }

    createMessage(params) {

        this.loading = true;

        const req = {
            method: 'POST',
            url: `${this.apiUrl}/sms-widget/`,
            data: params
        }

        return this.$http(req).then((res) => {
            this.success = true;
            this.showSuccessToast();
            return res.data;
        }, () => {
            this.showErrorToast();
        }).finally(() => {
            this.loading = false;
        });
    }


}

export default TecobiSmsWidgetService;



// WEBPACK FOOTER //
// ./client/app/components/tecobiSmsWidget/tecobiSmsWidget.service.js